"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/slicedToArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __importStar(require("lodash"));

var UtilsTime = __importStar(require("./time"));

var UtilsGenericItem = __importStar(require("./generic-item"));

var UtilsRow = __importStar(require("./row"));

var items_sort_reserved_words_1 = __importDefault(require("../constants/items-sort-reserved-words"));

var UtilsFileCache = __importStar(require("./file-cache"));

var remote_item_approve_state_1 = __importDefault(require("../constants/remote-item-approve-state"));

var column_type_1 = __importDefault(require("../constants/column-type"));

var UtilsColumnGroup = __importStar(require("./column-group"));

var api_1 = __importDefault(require("../api"));

var app_1 = require("../configs/app");

var sort_1 = require("../constants/sort");

function getWebShareLink(item) {
  return "https://".concat(app_1.WEB_DOMAIN, "/share/item/").concat(item.id);
}

exports.getWebShareLink = getWebShareLink;

function getAppShareLink(item) {
  return "".concat(app_1.APP_SCHEME, ":///item/").concat(item.id);
}

exports.getAppShareLink = getAppShareLink;

function getDefaultSortInfo(item) {
  return UtilsTime.getLightGap(item.edit_at);
}

exports.getDefaultSortInfo = getDefaultSortInfo;

function getSortInfo(item, sortOption, defaultValue) {
  switch (sortOption.type) {
    case sort_1.SORT_OPTION_TYPE.APP:
      {
        switch (sortOption.content) {
          case sort_1.SORT_OPTION_APP_TYPE.EDIT_AT:
            return UtilsTime.getLightGap(item.edit_at);

          case sort_1.SORT_OPTION_APP_TYPE.CREATE_AT:
            return UtilsTime.getLightGap(item.create_at);

          default:
            return defaultValue || '';
        }
      }

    case sort_1.SORT_OPTION_TYPE.ROW:
      {
        return getSortInfoFromData(item, sortOption.content, defaultValue);
      }

    default:
      {
        return defaultValue || '';
      }
  }
}

exports.getSortInfo = getSortInfo;

function getSortInfoFromData(item, columnGroup, defaultValue) {
  var rows = getRows(item);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var row = _step.value;
      var info = UtilsRow.getSortInfo(row, columnGroup);

      if (info !== null) {
        return info;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return defaultValue || '';
}

function getSubinfoBySort(item, sortId, defaultValue) {
  switch (sortId) {
    case items_sort_reserved_words_1.default.CREATE_AT:
      return UtilsTime.getLightGap(item.create_at);

    case items_sort_reserved_words_1.default.EDIT_AT:
      return UtilsTime.getLightGap(item.edit_at);

    case items_sort_reserved_words_1.default.TITLE:
    case items_sort_reserved_words_1.default.SUBTITLE:
      return '';

    default:
      {
        var rows = UtilsGenericItem.getRows(item);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = rows[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var row = _step2.value;

            var _UtilsRow$getSubinfoB = UtilsRow.getSubinfoBySort(row, sortId),
                _UtilsRow$getSubinfoB2 = _slicedToArray(_UtilsRow$getSubinfoB, 2),
                isFound = _UtilsRow$getSubinfoB2[0],
                subinfoByRow = _UtilsRow$getSubinfoB2[1];

            if (isFound) {
              return subinfoByRow || '';
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (defaultValue) {
          return defaultValue;
        } else {
          return '';
        }
      }
  }
}

exports.getSubinfoBySort = getSubinfoBySort;

function getItemsByGroupId(_x) {
  return _getItemsByGroupId.apply(this, arguments);
}

function _getItemsByGroupId() {
  _getItemsByGroupId = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(opts) {
    var groupId, isOnlyMine, isReload, cached, now, allItems, edit_at, items, latestItems, deletedItemIds, updatedItems, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _loop, _iterator9, _step9, updatedCache;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            groupId = opts.groupId, isOnlyMine = opts.isOnlyMine, isReload = opts.isReload;
            _context.next = 3;
            return UtilsFileCache.getItemsCacheByGroupId(groupId);

          case 3:
            cached = _context.sent;
            now = Date.now();

            if (!(isReload || cached === null)) {
              _context.next = 30;
              break;
            }

            _context.t0 = api_1.default.Items;
            _context.t1 = groupId;
            _context.t2 = remote_item_approve_state_1.default.APPROVED;

            if (!isOnlyMine) {
              _context.next = 15;
              break;
            }

            _context.next = 12;
            return api_1.default.Auth.getUserId();

          case 12:
            _context.t3 = _context.sent;
            _context.next = 16;
            break;

          case 15:
            _context.t3 = null;

          case 16:
            _context.t4 = _context.t3;
            _context.t5 = {
              groupId: _context.t1,
              orderBy: 'asc',
              approveState: _context.t2,
              ownerId: _context.t4
            };
            _context.next = 20;
            return _context.t0.load.call(_context.t0, _context.t5);

          case 20:
            allItems = _context.sent;

            if (!(allItems.length > 0)) {
              _context.next = 27;
              break;
            }

            _context.next = 24;
            return UtilsFileCache.writeItemsCache(groupId, {
              edit_at: now,
              create_at: now,
              items: allItems
            });

          case 24:
            return _context.abrupt("return", allItems);

          case 27:
            return _context.abrupt("return", []);

          case 28:
            _context.next = 80;
            break;

          case 30:
            edit_at = cached.edit_at, items = cached.items;
            _context.t6 = api_1.default.Items;
            _context.t7 = groupId;
            _context.t8 = edit_at;
            _context.t9 = remote_item_approve_state_1.default.APPROVED;

            if (!isOnlyMine) {
              _context.next = 41;
              break;
            }

            _context.next = 38;
            return api_1.default.Auth.getUserId();

          case 38:
            _context.t10 = _context.sent;
            _context.next = 42;
            break;

          case 41:
            _context.t10 = null;

          case 42:
            _context.t11 = _context.t10;
            _context.t12 = {
              groupId: _context.t7,
              startAfter: _context.t8,
              orderBy: 'asc',
              approveState: _context.t9,
              ownerId: _context.t11
            };
            _context.next = 46;
            return _context.t6.load.call(_context.t6, _context.t12);

          case 46:
            latestItems = _context.sent;
            _context.next = 49;
            return api_1.default.DeletedItems.getItemIdsAfter({
              after: edit_at,
              group_id: groupId
            });

          case 49:
            deletedItemIds = _context.sent;

            if (!(latestItems.length > 0 || deletedItemIds.length > 0)) {
              _context.next = 79;
              break;
            }

            updatedItems = items;
            _iteratorNormalCompletion9 = true;
            _didIteratorError9 = false;
            _iteratorError9 = undefined;
            _context.prev = 55;

            _loop = function _loop() {
              var latestItem = _step9.value;

              _.remove(updatedItems, function (item) {
                return item.id === latestItem.id;
              });

              updatedItems.push(latestItem);
            };

            for (_iterator9 = latestItems[Symbol.iterator](); !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              _loop();
            }

            _context.next = 64;
            break;

          case 60:
            _context.prev = 60;
            _context.t13 = _context["catch"](55);
            _didIteratorError9 = true;
            _iteratorError9 = _context.t13;

          case 64:
            _context.prev = 64;
            _context.prev = 65;

            if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
              _iterator9.return();
            }

          case 67:
            _context.prev = 67;

            if (!_didIteratorError9) {
              _context.next = 70;
              break;
            }

            throw _iteratorError9;

          case 70:
            return _context.finish(67);

          case 71:
            return _context.finish(64);

          case 72:
            if (deletedItemIds.length > 0) {
              _.remove(updatedItems, function (item) {
                return deletedItemIds.indexOf(item.id) !== -1;
              });
            }

            updatedCache = Object.assign({}, cached, {
              edit_at: now,
              items: updatedItems
            });
            _context.next = 76;
            return UtilsFileCache.writeItemsCache(groupId, updatedCache);

          case 76:
            return _context.abrupt("return", updatedItems);

          case 79:
            return _context.abrupt("return", items);

          case 80:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[55, 60, 64, 72], [65,, 67, 71]]);
  }));
  return _getItemsByGroupId.apply(this, arguments);
}

exports.getItemsByGroupId = getItemsByGroupId;

function getQuickFilterOptions(items) {
  var result = [];
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = items[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var item = _step3.value;
      var rows = item.rows;
      var opts = UtilsRow.getQuickFilterOptions(rows);

      if (opts.length > 0) {
        result = _.concat(result, opts);
        result = _.uniqWith(result, _.isEqual);
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return result;
}

exports.getQuickFilterOptions = getQuickFilterOptions;

function getQuickFilterOptionContent(items, option) {
  var contentByAllItems = [];
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = items[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var item = _step4.value;
      var rows = item.rows;

      if (rows.length === 0) {
        continue;
      }

      var contentsByOneItem = UtilsRow.getQuickFilterOptionContent(rows, option);

      if (contentsByOneItem.length > 0) {
        contentByAllItems = _.concat(contentByAllItems, contentsByOneItem);
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  if (contentByAllItems.length === 0) {
    return null;
  }

  return mergeQuickFilterOptionContents(contentByAllItems);
}

exports.getQuickFilterOptionContent = getQuickFilterOptionContent;

function mergeQuickFilterOptionContents(contents) {
  var hasRate = false;
  var numList = [];
  var strList = [];
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = contents[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var content = _step5.value;

      switch (content.type) {
        case column_type_1.default.BOOLEAN:
          return {
            type: column_type_1.default.BOOLEAN
          };

        case column_type_1.default.RATE:
          hasRate = true;
          break;

        case column_type_1.default.NUMBER:
          numList = _.concat(numList, _.get(content, 'list', []));
          break;

        case column_type_1.default.SHORT:
          strList = _.concat(strList, _.get(content, 'list', []));
          break;
      }
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  if (hasRate) {
    return {
      type: column_type_1.default.RATE
    };
  } else if (numList.length > 0) {
    return {
      type: column_type_1.default.NUMBER,
      list: _.uniq(numList).sort(function (a, b) {
        return a - b;
      })
    };
  } else if (strList.length > 0) {
    return {
      type: column_type_1.default.SHORT,
      list: _.uniq(strList).sort()
    };
  } else {
    console.warn("no suitable group quick filter type found");
    return null;
  }
}

function checkIfSuitQuickFilter(item, query) {
  var rows = item.rows;
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = rows[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var row = _step6.value;

      if (UtilsRow.checkIfSuitQuickFilter(row, query)) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  return false;
}

exports.checkIfSuitQuickFilter = checkIfSuitQuickFilter;

function checkIfItemSuitAllQuickFilter(item, querys) {
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = querys[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var query = _step7.value;

      if (!checkIfSuitQuickFilter(item, query)) {
        return false;
      }
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  return true;
}

exports.checkIfItemSuitAllQuickFilter = checkIfItemSuitAllQuickFilter;

function getRows(item) {
  return _.get(item, 'rows', []);
}

exports.getRows = getRows;

function extractColumnGroupsFromItems(items) {
  var groups = items.reduce(function (acc, cur) {
    return _.concat(acc, extractColumnGroups(cur));
  }, []);
  return UtilsColumnGroup.deDuplicate(groups);
}

exports.extractColumnGroupsFromItems = extractColumnGroupsFromItems;

function extractColumnGroups(item) {
  var rows = getRows(item);
  var groups = rows.reduce(function (acc, cur) {
    return _.concat(acc, UtilsRow.extractColumnGroups(cur));
  }, []);
  return UtilsColumnGroup.deDuplicate(groups);
}

exports.extractColumnGroups = extractColumnGroups;

function sort(items, option) {
  switch (option.type) {
    case sort_1.SORT_OPTION_TYPE.APP:
      return sortByBuiltInType(items, option.content);

    case sort_1.SORT_OPTION_TYPE.ROW:
      return _.sortBy(items, function (item) {
        return getSortComparator(item, option.content);
      });

    default:
      console.error("Can not identify sort type ".concat(option));
      return items;
  }
}

exports.sort = sort;

function sortByBuiltInType(items, type) {
  switch (type) {
    case sort_1.SORT_OPTION_APP_TYPE.EDIT_AT:
      return _.sortBy(items, 'edit_at');

    case sort_1.SORT_OPTION_APP_TYPE.CREATE_AT:
      return _.sortBy(items, 'create_at');

    case sort_1.SORT_OPTION_APP_TYPE.TITLE:
      return _.sortBy(items, 'title');

    case sort_1.SORT_OPTION_APP_TYPE.SUBTITLE:
      return _.sortBy(items, 'subtitle');

    case sort_1.SORT_OPTION_APP_TYPE.CANCEL:
      return items;

    default:
      console.error("Can not identify built in sort type: ".concat(type));
      return items;
  }
}

function getSortComparator(item, columnGroup) {
  var rows = getRows(item);
  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    for (var _iterator8 = rows[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      var row = _step8.value;
      var comparator = UtilsRow.getSortComparator(row, columnGroup);

      if (comparator !== null) {
        return comparator;
      }
    }
  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
        _iterator8.return();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }

  return null;
}

function findItemById(items, id) {
  return _.find(items, {
    id: id
  });
}

exports.findItemById = findItemById;